import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';
import { GeometricFormState } from '../../state/geometric-form.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'building' })
export class BuildingStore extends EntityStore<GeometricFormState> {

  constructor() {
    super({
      ui: { visible: false }
    });
    this.setLoading(false);
  }

}
